export type IllustrationName =
  | 'absences'
  | 'calculator'
  | 'calculators'
  | 'capterra'
  | 'career'
  | 'clock'
  | 'customers'
  | 'discount'
  | 'exc_expert'
  | 'expenses'
  | 'first_pay'
  | 'folder'
  | 'golden_ribbon'
  | 'google'
  | 'guides'
  | 'integration'
  | 'lightbulb'
  | 'management'
  | 'models_blue'
  | 'models_yellow'
  | 'payFit'
  | 'payfit_small'
  | 'payroll'
  | 'people'
  | 'people_headphone_man'
  | 'people_headphone_woman'
  | 'plan_paie'
  | 'plan_paie_avancee'
  | 'plan_rhplus'
  | 'plan_starter'
  | 'rocket'
  | 'setting_slider'
  | 'site_check'
  | 'timetracking'
  | 'timetracking_purple'
  | 'trustpilot'
  | 'try_it_yourself';

export const illustrationsLibrary: IllustrationName[] = [
  'absences',
  'calculator',
  'calculators',
  'capterra',
  'career',
  'clock',
  'customers',
  'discount',
  'exc_expert',
  'expenses',
  'first_pay',
  'folder',
  'golden_ribbon',
  'google',
  'guides',
  'integration',
  'lightbulb',
  'management',
  'models_blue',
  'models_yellow',
  'payFit',
  'payfit_small',
  'payroll',
  'people',
  'people_headphone_man',
  'people_headphone_woman',
  'plan_paie',
  'plan_paie_avancee',
  'plan_rhplus',
  'plan_starter',
  'rocket',
  'setting_slider',
  'site_check',
  'timetracking',
  'timetracking_purple',
  'trustpilot',
  'try_it_yourself',
];
